export default {
    data: () => ({
        sortedEvents: [],
        sortedEventsArtist: []
    }),
    methods: {
        sortByDate(events) {
            const upcomingEvents = events
                .filter((e) => e.status === 0 || e.status === 1 || e.status === 2)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            const wrapUp = events.filter((e) => e.status === 3)
            const completedEvents = events
                .filter((e) => e.status === 4)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            const cancelledEvents = events
                .filter((e) => e.status === 5)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            return (this.sortedEvents = [...upcomingEvents, ...wrapUp, ...completedEvents, ...cancelledEvents])
        },
        sortByDateForArtist(events) {
            const upcomingEvents = events
                .filter(
                    (e) =>
                        (e.event_status === 0 || e.event_status === 1 || e.event_status === 2) &&
                        e.event_artist_status !== 4
                )
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            const wrapUp = events
                .filter((e) => e.event_status === 3)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            const completedEvents = events
                .filter((e) => e.event_status === 4)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            const cancelledEvents = events
                .filter((e) => e.event_status === 6 || e.event_status === 5 || e.event_artist_status === 4)
                .sort((a, b) => new Date(a.end_date) - new Date(b.end_date))
            return (this.sortedEvents = [...upcomingEvents, ...wrapUp, ...completedEvents, ...cancelledEvents])
        }
    }
}
